import { ComponentType, createElement, isValidElement, ReactElement } from "react";
import Spinner from "../spinner/spinner";
import { IProps } from "./spinner-until.types";

/**
 * Show a spinner until some content is ready.
 * @param props.children    Children to display when ready.
 * @param props.isReady     True when the content is loaded.
 * @param props.data        Data to pass to the children when ready.
 * @param props.spinner     Spinner to show while loading. It can be a component type or an element.
 * @returns A spinner while something is loading or the content when it's available.
 */
function SpinnerUntil<T>({ children, data, isReady, spinner }: IProps<T>) {
    const SpinnerComponent = spinner || Spinner;
    let SpinnerElement: ReactElement;
    if (isValidElement(SpinnerComponent)) {
        SpinnerElement = SpinnerComponent;
    } else {
        SpinnerElement = createElement(SpinnerComponent as ComponentType);
    }

    return isReady ? <>{typeof children === "function" ? children(data) : children}</> : SpinnerElement;
}

export default SpinnerUntil;
